import styles from '../styles.module.css';
import MissionCompleteDay from './MissionCompleteDay';

const MissionCompleteDayList = ({allDays, completeDays}) => {
  return (
    <ul className={styles.mission_list}>
      {allDays &&
        allDays.length > 0 &&
        allDays.map((item, index) => (
          <MissionCompleteDay
            key={item}
            isDone={completeDays?.includes(item)}
            dayCount={index + 1}
            dateString={item}
          />
        ))}
    </ul>
  );
};

export default MissionCompleteDayList;
